import React from "react";
import styles from "./AssistantSetUp.module.css"
import {Section} from "../../../../../../elements/section/Section";
import {FullBotUi} from "../../../../../../../api/generated";
import {TextFieldsLine} from "../../../../../../elements/textFieldsLine/TextFieldsLine";
import {LeftSideTextField} from "../../../../../../elements/leftSideTextField/LeftSideTextField";
import {
    DEFAULT_SUPPORTED_PHONE_NUMBER_LOCALES,
    getSupportedPhoneLocaleLabel
} from "../../../../phoneLocaleUtil";
import {getOpenAiModelLabel} from "../../../../modal/createAndUpdate/components/util/openAiModelUtil";

interface AssistantSetUpProps {
    bot: FullBotUi
}

export const AssistantSetUp: React.FC<AssistantSetUpProps> = ({
                                                                  bot
                                                              }) => {
    const supportedPhoneLocales = (bot.supportedPhoneNumberLocales?.length
        ? bot.supportedPhoneNumberLocales
        : DEFAULT_SUPPORTED_PHONE_NUMBER_LOCALES)
        .map(getSupportedPhoneLocaleLabel)
        .join("; ");

    return <Section title={"Assistant Set-Up"}>
        <div className={styles.fieldsWrapper}>
            <TextFieldsLine
                leftFieldTitle={"Site Name"}
                leftFieldValue={bot.siteName}
                rightFieldTitle={"Transcript Recipient(s)"}
                rightFieldValue={bot.emailTranscriptRecipients.join("; ")}
            />
            <TextFieldsLine
                leftFieldTitle={"Assistant Email"}
                leftFieldValue={bot.assistantEmail}
                rightFieldTitle={"Assistant Email Password"}
                rightFieldValue={bot.assistantEmailPassword}
            />
            <LeftSideTextField
                title={"Transcript Filtration"}
                value={bot.filtrationEnabled ? "Enabled" : "Disabled"}
            />
            <LeftSideTextField
                title={"Transcript Summary"}
                value={bot.transcriptSummaryEnabled ? "Enabled" : "Disabled"}
            />
            <LeftSideTextField
                title={"Sharing Link"}
                value={bot.sharingLinkEnabled ? "Enabled" : "Disabled"}
            />
            <LeftSideTextField
                title={"Supported Phone Number Locales"}
                value={supportedPhoneLocales}
            />
            <LeftSideTextField
                title={"OpenAI Model"}
                value={getOpenAiModelLabel(bot.openAiModel)}
            />
        </div>
    </Section>
}
